import { ArrowLeft, Check, Save } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

type SubPageHeaderProps = {
  title: string;
  subtitle?: string;
  saving: boolean;
  saveSuccess: boolean;
  savingLabel: string;
  saveCompleteLabel: string;
  saveLabel: string;
  onBack: () => void;
  onSave: () => void;
};

export default function SubPageHeader({
  title,
  subtitle,
  saving,
  saveSuccess,
  savingLabel,
  saveCompleteLabel,
  saveLabel,
  onBack,
  onSave,
}: SubPageHeaderProps) {
  const { t } = useTranslation();
  return (
    <header className="sticky top-0 z-10 flex items-center justify-between border-b border-border bg-background/95 px-4 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:px-8 safe-top">
      <div className="flex items-center gap-3">
        <Button
          type="button"
          variant="secondary"
          size="icon"
          onClick={onBack}
          aria-label={t("common.go_back")}
        >
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-lg font-bold text-foreground">{title}</h1>
          {subtitle ? (
            <p className="text-xs text-muted-foreground">{subtitle}</p>
          ) : null}
        </div>
      </div>
      <Button
        type="button"
        variant="gradient"
        onClick={onSave}
        disabled={saving}
        loading={saving}
      >
        {saving ? (
          savingLabel
        ) : saveSuccess ? (
          <>
            <Check className="h-4 w-4" aria-hidden="true" />
            {saveCompleteLabel}
          </>
        ) : (
          <>
            <Save className="h-4 w-4" aria-hidden="true" />
            {saveLabel}
          </>
        )}
      </Button>
    </header>
  );
}
